const routes = {
    '/': 'Home',
    '/dashboard': 'Dashboard',
    '/components': 'Components',
    '/requests': 'Tractor Requests',
    '/farmers': 'Farmers',
    '/fbo': 'FBO',
    '/profile':'Account Profile',
    '/tractors': 'Tractors',
    '/maps': 'Maps',
    '/operators': 'Operators',
    '/tractor_owners': 'Tractor Owners',
    '/transactions': 'Transactions',
    '/users' : 'Users',
    '/account/tickets': 'Tickets',
    '/services/ussd': 'USSD',
    '/services/broadcast': 'Broadcast',
    '/management/settings': 'Settings',
    '/support/feedback': 'User Feedback',
    '/support/tickets': 'User Tickets Support',
    '/support/tickets_management': 'Ticket Management',
    '/finance/payout': 'Payouts',
    '/finance/command/agric/payments': [ 'Finance','CBZ Command Agric', 'Bank Payments' ],
    '/finance/command/agric/create/payment': ['Finance' , 'CBZ Command Agric' , 'Create Bank Payment' ],
    '/finance/command/agric/payment/detail/:id': ['Finance' , 'CBZ Command Agric' , 'Bank Payment Detail' ]
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js